import { takeEvery, call, put, fork, all } from 'redux-saga/effects';
import * as actions from '../actions/materialActions';
import * as alertActions from '../actions/alertActions'
import * as api from '../api/afterSalesDataServices';
import { loadMalzeme, saveMalzeme } from 'src/utils/storage/Material'

function* getMaterials(params) {
  try {
    if (!params.kulModelKodu || !params.garantiTipi) {
      throw new Error('Model Kodu veya Garanti tipi Girilmemiş');
    }
    let data = loadMalzeme(params.kulModelKodu,params.garantiTipi);
    if (data.length === 0 && window.navigator.onLine) {
      const result = yield call(api.getMaterials, params);
      data = result.data === "" ? [] : result.data;
      saveMalzeme(params.kulModelKodu,params.garantiTipi, data);
    }
    yield put(actions.getMaterialSuccess(data));
  } catch (error) {
    yield put(actions.setMaterialError(error));
  }
}

function* watchGetMaterialRequest() {
  yield takeEvery(actions.Types.GET_MATERIAL_REQUEST, getMaterials);
}

function* getHistoricalMaterials(params) {
  try {
    if (!params.kulModelKodu || !params.garantiTipi) {
      throw new Error('Model Kodu veya Garanti tipi Girilmemiş');
    }
    let data = [];
    let alertMessage = 'Internet bağlantınız olmadığı için tarihsel ağaç verisi alınamadı!..';
    if (window.navigator.onLine) {
      const result = yield call(api.getHistoricalMaterials, params);
      data = result.data === "" ? [] : result.data;
      let count = data.filter(d => d.HistoricalBom === 1).length;
      alertMessage = count === 0 ? 'Ürüne ait Tarihsel Ağaç Yok!...' : 'Ürüne ait Tarihsel Ağaç Verisi Alındı.';
      saveMalzeme(params.kulModelKodu, params.garantiTipi,data);
    }
    yield all([
      put(actions.getMaterialSuccess(data)),
      put(alertActions.setAlert(alertMessage, 'Bilgilendirme')),
    ]);
  } catch (error) {
    yield put(actions.setMaterialError(error));
  }
}

function* watchGetHistoricalMaterialRequest() {
  yield takeEvery(actions.Types.GET_HISTORICAL_MATERIAL_REQUEST, getHistoricalMaterials);
}

const materialSagas = [fork(watchGetMaterialRequest), fork(watchGetHistoricalMaterialRequest)];

export default materialSagas;
